import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { msgid, ngettext, t } from 'ttag';

import MessageInfoIcon from '@svg/message-info.svg';
import { smartLanding } from '@urls';
import { useTimer } from '@hook/useTimer';
import { Link } from '@ui/Link';

import s from './ProductDetailsSpecialSmartPriceBanner.sss';

interface Props {
  className?: string,
  title: string,
  availableUntilTheTime: string,
}

export const ProductDetailsSpecialSmartPriceBanner: React.FC<Props> = ({
  className,
  title,
  availableUntilTheTime,
}) => {
  const history = useHistory();

  const { duration } = useTimer({
    initialStart: true,
    initialTime: dayjs.duration(dayjs(availableUntilTheTime).diff()),
  });

  const daysCount = Math.floor(duration.asDays());
  const countDown = duration.format('HH:mm:ss');
  const daysText = ngettext(
    msgid`${daysCount} день`,
    `${daysCount} дні`,
    `${daysCount} днів`,
    daysCount,
  );

  const timerText = daysCount > 0 ? daysText : countDown;
  const landingUrl = history.createHref({ pathname: smartLanding });

  return (
    <Link
      className={classNames(s.link, className)}
      theme="clean"
      href={landingUrl}
    >
      <p
        className={s.title}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p className={s.timer}>
        {t`До кінця акції ${timerText}`}
      </p>

      <MessageInfoIcon
        className={s.icon}
        width="16"
        height="16"
      />
    </Link>
  );
};
